// Effective customer-facing base price: the server-computed promo price when a discount
// (product discount / Happy Hour / restaurant-wide) is running, otherwise the base price.
// Paid modifiers are never discounted. The backend remains authoritative at order creation.
export function effectiveBase(product) {
  if (!product) return 0;
  return product.happy_hour ? product.happy_hour.price : product.price;
}
